// 通用弹窗插件
(function(global){
  function ThemePopup(options) {
    this.options = Object.assign({
      content: '',
      popupClass:"",
      class:"",
      mask: true,
      closeOnMask: true,
      onOpen: null,
      onClose: null
    }, options || {});
    this._init();
  }
  ThemePopup.prototype._init = function() {
    // 创建遮罩
    if(this.options.mask) {
      this.mask = document.createElement('div');
      this.mask.className = 'theme-popup-mask';
      document.body.appendChild(this.mask);
      if(this.options.closeOnMask) {
        this.mask.addEventListener('click', this.close.bind(this));
      }
    }
    // 创建弹窗
    this.popup = document.createElement('div');
    this.popup.className = 'theme-popup-box ' + this.options.popupClass;
    this.popup.innerHTML = '<div class="theme-popup-content ' + this.options.class + '"><span class="theme-popup-close">×</span>' + this.options.content + "</div>";
    // 优化：只点击遮罩关闭，点击内容区不关闭
    this.popup.onclick = (e) => {
      if (e.target === this.popup) {
        this.close();
      }
    };
    document.body.appendChild(this.popup);
    this.popup.querySelector('.theme-popup-close').onclick = this.close.bind(this);
    if(typeof this.options.onOpen === 'function') this.options.onOpen();
  };
  ThemePopup.prototype.close = function() {
    if(this.mask) document.body.removeChild(this.mask);
    if(this.popup) document.body.removeChild(this.popup);
    if(typeof this.options.onClose === 'function') this.options.onClose();
  };
  global.ThemePopup = ThemePopup;
})(window);



/****
 * 
 * 
new ThemePopup({
    content: html,
    onClose: function(){
        
    }
});
 */